import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import lamboRear from "@/assets/lambo-rear.jpg";
import paganiRear from "@/assets/pagani-rear.jpg";
import bugattiGreenFront from "@/assets/gallery/bugatti-green-front.jpg";
import koenigseggGumball from "@/assets/gallery/koenigsegg-gumball.jpg";
import porscheGt3Shop from "@/assets/gallery/porsche-gt3-shop.jpg";
import mclarenGreen from "@/assets/gallery/mclaren-green.jpg";
import { Button } from "@/components/ui/button";

const images = [{
  src: bugattiGreenFront,
  alt: "Green Bugatti Chiron with PPF protection at Hyper Haus Los Angeles",
  label: "Bugatti Chiron",
}, {
  src: lamboRear,
  alt: "Lamborghini Diablo GT rear view — full body PPF by Hyper Haus",
  label: "Lamborghini Diablo GT",
}, {
  src: porscheGt3Shop,
  alt: "Porsche GT3 RS in the Hyper Haus shop receiving PPF installation",
  label: "Porsche GT3 RS",
}, {
  src: koenigseggGumball,
  alt: "Koenigsegg Regera Gumball 3000 edition serviced at Hyper Haus LA",
  label: "Koenigsegg Regera",
}, {
  src: paganiRear,
  alt: "Pagani Huayra R rear — full body PPF by Hyper Haus",
  label: "Pagani Huayra R",
}, {
  src: mclarenGreen,
  alt: "Green McLaren 650S with full body PPF by Hyper Haus",
  label: "McLaren 650S",
}];

const Gallery = () => {
  return (
    <section className="py-24 bg-card">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-primary text-sm uppercase tracking-[0.3em] mb-4">Our Work</p>
          <h2 className="section-heading mb-4">Gallery</h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {images.map((image, index) => (
            <motion.div
              key={image.alt}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="aspect-[4/3] overflow-hidden rounded-lg relative group"
            >
              <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
                width={400}
                height={300}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background/80 to-transparent p-3 pt-8">
                <p className="text-xs font-medium text-foreground">{image.label}</p>
                <p className="text-[10px] text-primary uppercase tracking-wider">Full Body PPF</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-12 text-center"
        >
          <a
            href="https://www.instagram.com/hyper.haus"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="outline" size="lg" className="gap-2 border-[#E1306C]/30 text-[#E1306C] hover:bg-[#E1306C]/10 hover:text-[#E1306C] hover:border-[#E1306C]/50">
              <Instagram className="w-5 h-5" />
              See More on Instagram
            </Button>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Gallery;